// Config stuff

const config = {
  API_BASE_URL: process.env.REACT_APP_API_URL,
  MAPBOX_TOKEN: process.env.REACT_APP_MAPBOX_ACCESS_TOKEN,
  
  // API endpoints
  TSP_SOLVE_API: '/api/tsp/solve',
  VRP_SOLVE_API: '/api/vrp/solve',
  MTO_SOLVE_API: '/api/mto/solve',
  TP_SOLVE_API: '/api/tp/solve',
  TP_DISTANCE_MATRIX_API: '/api/tp/distance-matrix',
  TP_SOLVE_TRANSPORT_API: '/api/tp/solve-transport',
  
  // Additional endpoints
  TSP_ALGORITHMS_API: '/api/tsp/algorithms',
  VRP_ALGORITHMS_API: '/api/vrp/algorithms',
  MTO_ALGORITHMS_API: '/api/mto/algorithms',
  DELETE_PATH_API: '/api/paths/delete',
  CLEAR_PATHS_API: '/api/paths/group',
  TSP_SAVE_CUSTOM_PATH: '/api/tsp/save-custom-path',
  PATHS_GET_API: '/api/paths',
  USER_PATH_COST_API: '/api/paths/cost',
  COMPARE_PATHS_API: '/api/paths/compare',
  VRP_SESSION_SAVE_AUTO_PATH: '/api/session/vrp/auto',
  VRP_SESSION_SAVE_CUSTOM_PATH: '/api/session/vrp/custom',
  VRP_SESSION_GET_PATHS: '/api/session/vrp',
  VRP_SESSION_CLEAR_ALL: '/api/session/vrp/clear',
  VRP_SESSION_CLEAR_AUTO_PATH: '/api/session/vrp/clear/auto',
  VRP_SESSION_CLEAR_CUSTOM_PATH: '/api/session/vrp/clear/custom',
  
  MTO_SESSION_SAVE_AUTO_PATH: '/api/session/mto/auto',
  MTO_SESSION_SAVE_CUSTOM_PATH: '/api/session/mto/custom',
  MTO_SESSION_GET_PATHS: '/api/session/mto',
  MTO_SESSION_CLEAR_ALL: '/api/session/mto/clear',
  MTO_SESSION_CLEAR_AUTO_PATH: '/api/session/mto/clear/auto',
  MTO_SESSION_CLEAR_CUSTOM_PATH: '/api/session/mto/clear/custom',
  
  // Map settings
  DEFAULT_CENTER: [-37.8136, 144.9631], // Melbourne
  DEFAULT_ZOOM: 12,
  
  // These seem to work okay
  MAX_LOCATIONS: 50,
  MAX_VEHICLES: 10,
  REQUEST_TIMEOUT: 30000,
};

// Build full API URLs
Object.keys(config).forEach(key => {
  if (key.endsWith('_API') || key.includes('_API') || 
      key === 'TSP_SAVE_CUSTOM_PATH' || 
      key === 'PATHS_GET_API' || 
      key === 'USER_PATH_COST_API' || 
      key === 'COMPARE_PATHS_API' || 
      key === 'DELETE_PATH_API' ||
      key === 'CLEAR_PATHS_API' ||
      key.startsWith('VRP_SESSION_') ||
      key.startsWith('MTO_SESSION_')) {
    config[key] = config.API_BASE_URL + config[key];
  }
});

export default config;

// Named exports for backwards compatibility
export const TSP_SOLVE_API = config.TSP_SOLVE_API;
export const VRP_SOLVE_API = config.VRP_SOLVE_API;
export const MTO_SOLVE_API = config.MTO_SOLVE_API;
export const TP_SOLVE_API = config.TP_SOLVE_API;
export const TP_DISTANCE_MATRIX_API = config.TP_DISTANCE_MATRIX_API;
export const TP_SOLVE_TRANSPORT_API = config.TP_SOLVE_TRANSPORT_API;
export const TSP_ALGORITHMS_API = config.TSP_ALGORITHMS_API;
export const VRP_ALGORITHMS_API = config.VRP_ALGORITHMS_API;
export const MTO_ALGORITHMS_API = config.MTO_ALGORITHMS_API;
export const DELETE_PATH_API = config.DELETE_PATH_API;
export const TSP_SAVE_CUSTOM_PATH = config.TSP_SAVE_CUSTOM_PATH;
export const PATHS_GET_API = config.PATHS_GET_API;
export const USER_PATH_COST_API = config.USER_PATH_COST_API;
export const COMPARE_PATHS_API = config.COMPARE_PATHS_API;
export const CLEAR_PATHS_API = config.CLEAR_PATHS_API;
export const VRP_SESSION_SAVE_AUTO_PATH = config.VRP_SESSION_SAVE_AUTO_PATH;
export const VRP_SESSION_SAVE_CUSTOM_PATH = config.VRP_SESSION_SAVE_CUSTOM_PATH;
export const VRP_SESSION_GET_PATHS = config.VRP_SESSION_GET_PATHS;
export const VRP_SESSION_CLEAR_ALL = config.VRP_SESSION_CLEAR_ALL;
export const VRP_SESSION_CLEAR_AUTO_PATH = config.VRP_SESSION_CLEAR_AUTO_PATH;
export const VRP_SESSION_CLEAR_CUSTOM_PATH = config.VRP_SESSION_CLEAR_CUSTOM_PATH;

export const MTO_SESSION_SAVE_AUTO_PATH = config.MTO_SESSION_SAVE_AUTO_PATH;
export const MTO_SESSION_SAVE_CUSTOM_PATH = config.MTO_SESSION_SAVE_CUSTOM_PATH;
export const MTO_SESSION_GET_PATHS = config.MTO_SESSION_GET_PATHS;
export const MTO_SESSION_CLEAR_ALL = config.MTO_SESSION_CLEAR_ALL;
export const MTO_SESSION_CLEAR_AUTO_PATH = config.MTO_SESSION_CLEAR_AUTO_PATH;
export const MTO_SESSION_CLEAR_CUSTOM_PATH = config.MTO_SESSION_CLEAR_CUSTOM_PATH;

export const API_BASE_URL = config.API_BASE_URL;